module.exports = __webpack_public_path__ + "img/baffleCenter.ee0752a4.png";